import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api-service/api.service';
// declare var $,jQuery: any;
import * as $ from 'jquery';

@Component({
  selector: 'app-page-cakendar',
  templateUrl: './page-calendar.component.html',
  styleUrls: ['./page-calendar.component.scss']
})
export class PageCalendarComponent implements OnInit{
 

  constructor(private apiService: ApiService) {
    setTimeout(function(){        
      $('.app-loading').css('display','flex');
      $('.app-loading').delay(1000).fadeOut('slow'); 
  }, 0);
  }


  Calendar = (): void => {
    $('ul.tabs__caption').on('click', 'li:not(.active)', function() {
      $(this)
        .addClass('active').siblings().removeClass('active')
        .closest('div.tabs').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
    });
  }

  ngOnInit() {
  }

}
